import { PackageNameEnum } from '@electricjs/core_entity-client';
import { OrganizationPackageWithEntitlements } from '@/types/packages';
import { ISOLVED_PACKAGE_NAMES } from '@/constants/packages';
import { CustomerRedirectSegment } from '@/constants/customerRedirects';

export const useCustomerRedirectSegment = (
  organizationPackages?: OrganizationPackageWithEntitlements[]
): CustomerRedirectSegment | undefined => {
  const isIsolvedCustomer = organizationPackages?.some(pkg =>
    ISOLVED_PACKAGE_NAMES.includes(pkg.package.name as PackageNameEnum)
  );

  if (isIsolvedCustomer) {
    return 'isolved';
  }

  return undefined;
};
